import { AddressDataDTO } from '@openApiGenerated/management-api';


// ENUMS #############################################################
export enum GermanFederalStateEnum {
	BADEN_WUERTTEMBERG = 'badenWuerttemberg',
	BAVARIA = 'bavaria',
	BERLIN = 'berlin',
	BRANDENBURG = 'brandenburg',
	BREMEN = 'bremen',
	HAMBURG = 'hamburg',
	HESSE = 'hesse',
	LOWER_SAXONY = 'lowerSaxony',
	MECKLENBURG_WESTERN_POMERANIA = 'mecklenburgWesternPomerania',
	NORTH_RHINE_WESTPHALIA = 'northRhineWestphalia',
	RHINELAND_PALATINATE = 'rhinelandPalatinate',
	SAARLAND = 'saarland',
	SAXONY = 'saxony',
	SAXONY_ANHALT = 'saxonyAnhalt',
	SCHLESWIG_HOLSTEIN = 'schleswigHolstein',
	THURINGIA = 'thuringia'
}


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

// MODEL USED IN APPLICATION (with additional properties)
export class Address {
	public additionalData: string = undefined;
	public city: string = undefined;
	public countryCode: string = undefined;
	public houseNumber?: string = undefined;
	public postalCode: string = undefined;
	public state: string = undefined;
	public street: string = undefined;
}

// INTERFACES ########################################################
export interface IAddressPairCheckItem {
	addressPairKeysList: AddressProps[];
	isSetToShow: boolean;
}

// TYPES #############################################################
export type AddressProps = ( keyof Address )[];

export type AddressType = Address | AddressDataDTO;
